import RegistrationAddressView from './components/RegistrationAddressView'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { useFetchAccountDetail } from '@/account/accountQueries'
import useCanGoBack from '@/common/hooks/useCanGoBack'
import { normalizeToAddressDetails } from '@/common/utils/utils'

export default function AccountRegistrationAddressView() {
    const { goBackSafely } = useCanGoBack()
    const account = useCurrentAccount()
    const { data: accountDetail } = useFetchAccountDetail(account?.accountId)

    if (!account) {
        return null
    }

    const initialAddress = normalizeToAddressDetails(accountDetail?.postalAddress)

    return (
        <RegistrationAddressView
            accountId={account.accountId}
            initialAddress={initialAddress}
            onSave={goBackSafely}
            onCancel={goBackSafely}
        />
    )
}
